import Box from "ds/components/Box";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { TemplateVersion } from "types/generated";
import { TemplateContext } from "views/Account/Template/Context";

import DeprecatedVersionBadge from "../../DeprecatedVersionBadge";

const TemplatesLatestVersionCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<TemplateVersion>) => {
  const { template: templateFromContext } = useTypedContext(TemplateContext);
  return (
    <TableSimpleCell {...cellProps}>
      <Box direction="row" align="center" gap="medium">
        <TableCellLink href={`/template/${templateFromContext.id}/version/${template.id}`}>
          {template.version}
        </TableCellLink>
        <DeprecatedVersionBadge deprecatedAt={template.deprecatedAt} />
      </Box>
    </TableSimpleCell>
  );
};

export default TemplatesLatestVersionCell;
